export default __webpack_public_path__ + "static/media/KeystoneLogo.31608f28.svg";